const DesktopSharing = () => {
    return <>Under development...</>
}

export default DesktopSharing 